import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { UntypedFormGroup,  UntypedFormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { MultiLangPipe  } from "../../pipes/multi-lang.pipe";
import { PageService } from 'src/app/services/page.service';
import { GatemanService } from "../../services/gateman.service";


interface SubmitButtonInterface  {
  backgroundColor?: string,
  borderColor?: string,
  text?: string ,
  color?: string,
  align?: string,
  size?: string
}

interface AfterSubmitInterface {
  mode?: number,
  message?: string,
  redirectUrl?: string
}

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})

export class FormComponent implements OnInit, AfterViewInit {

  @Input() controls: Array<any> = [];
  @Input() public config: {
    name?: string
    submitButton?: {
      backgroundColor?: string,
      borderColor?: string,
      text?: string | Array<{languageCode: string, value: string}>,
      color?: string,
      align?: string,
      size? : string
    },
    afterSubmit? : {
      mode?: number,
      message?: Array<{languageCode: string, value: string}>,
      redirectUrl?: Array<{languageCode: string, value: string}>
    },
    patchForm?:string,
    formType?: string
  };

  @Input() public data:any = {};

  form: UntypedFormGroup;
  param;
  templateId;
  shortCode;
  formFields = [];
  inProgress = false;
  errorMessage = false;

  hideForm = false;

  submitButton: SubmitButtonInterface = {
    backgroundColor: `#10dc60`,
    borderColor: `#10dc60`,
    text: `Submit`,
    color: `#ffffff`,
    align: `flex-start`,
    size: 'default'
    };

  afterSubmit: AfterSubmitInterface = {
    mode : 1,
    message: "<h4>Form Submitted Successfully</h4>"
  }

  @ViewChild('submitButtonRef', { read: ElementRef }) submitButtonRef;
  wrapperStyle: any;

  formType = '1';
  constructor(private fb: UntypedFormBuilder,
              private route: ActivatedRoute,
              public apiService: ApiService,
              private renderer: Renderer2,
              private pageService: PageService,
              public multiLangPipe: MultiLangPipe,
              public gatemanService: GatemanService
  ) { }

  ngOnInit() {

    this.formType = '1';
    try {
      const { formType, patchForm} = this.config;

      if(formType && patchForm ) {
        this.formType = formType;
      }

    } catch(e) {
      console.log('something went wrong with formType')
    }


    let { shortcode = null, iid = null, eid=null } = {...this.route.snapshot.params};
    const linkTypeId = this.route.snapshot.queryParamMap.get('linkTypeId');
    //console.log(this.route, this.pageService.isDigitalLinkInteraction);
    //console.log('getDIByDigitalLink', this.pageService.isDigitalLinkInteraction);
    

    if(this.pageService.isDigitalLinkInteraction) {
      //For digitallinks manually set templateid and instanceId
      this.templateId = this.pageService.ditemplateId

    } else {

      if (shortcode) {
        this.shortCode = shortcode;
      }
      if (iid) {
        this.templateId = iid;
      }

      if(eid) {

        if(linkTypeId) {
          this.templateId = linkTypeId;
        }
        
      }

    }

    
    if (this.controls.length > 0) {
      this.getFormFields(this.controls);
    }
    this.buildForm();
  
    if(this.config.hasOwnProperty("submitButton")){
    
      if(this.config.submitButton.hasOwnProperty("backgroundColor") && this.config.submitButton.backgroundColor && this.config.submitButton.backgroundColor != ''){
       this.submitButton.backgroundColor = this.config.submitButton.backgroundColor;
    
        // in config, if borderColor is not present || '', use backgroundColor
        if(this.config.submitButton.hasOwnProperty("borderColor") && this.config.submitButton.borderColor && this.config.submitButton.borderColor != ''){
          this.submitButton.borderColor = this.config.submitButton.borderColor;
        } else {
          this.submitButton.borderColor = this.config.submitButton.backgroundColor
        }
      }

     
      
      if(this.config.submitButton.hasOwnProperty("text") && this.config.submitButton.text){
        let text = this.multiLangPipe.transform(this.config.submitButton.text);
        if(text && text!= '') {
          this.submitButton.text = text.toString();
        }
      }

      if(this.config.submitButton.hasOwnProperty("color") && this.config.submitButton.color && this.config.submitButton.color != ''){
        this.submitButton.color = this.config.submitButton.color;
      }

      if(this.config.submitButton.hasOwnProperty("align") && this.config.submitButton.align && this.config.submitButton.align != ''){
        this.submitButton.align = this.config.submitButton.align;
      }

      if(this.config.submitButton.hasOwnProperty("size") && this.config.submitButton.size && this.config.submitButton.size != ''){
        this.submitButton.size = this.config.submitButton.size;
      }
    }


    // afterSubmit 
    //if afterSubmit present, check for mode
    if(this.config && this.config.hasOwnProperty("afterSubmit") && this.config.afterSubmit) {
      //if mode is present, check if 1 or 2
      if(this.config.afterSubmit.hasOwnProperty("mode") && this.config.afterSubmit.mode) {
        //mode is Text => message array
        if(this.config.afterSubmit.mode === 1) {
          if(this.config.afterSubmit.hasOwnProperty("message") && this.config.afterSubmit.message && this.config.afterSubmit.message.length > 0) {
           this.afterSubmit.message = this.multiLangPipe.transform(this.config.afterSubmit.message).toString();
          }
        }
        //mode is redirectUrl => redirect url array
        if(this.config.afterSubmit.mode === 2) {
          this.afterSubmit.mode = this.config.afterSubmit.mode;
          //console.log("mode is redirectUrl: 2");
          if(this.config.afterSubmit.hasOwnProperty("redirectUrl") &&this.config.afterSubmit.redirectUrl && this.config.afterSubmit.redirectUrl.length > 0) {
            let url = this.multiLangPipe.transform(this.config.afterSubmit.redirectUrl);
            //if url is present set this.redirectUrl to redirect after submit button is clicked
            if(url && url != '') {
              this.afterSubmit.redirectUrl = url.toString();
            } 
          }
        }
      }
    }
   
    this.wrapperStyle = this.getWrapperStyle();

  }

  /**
   * [Form creation function]
   * @task QLIKTAG-3376
   * @author Lalitkumar Saindane
   */
  buildForm() {
    let fields;

    fields = this.formFields.reduce((acc= {}, field, index) => {

      let searchArray = [];
      let match;

      searchArray = [...this.formFields.slice(0, index)];

      // If duplicate fieldName is found
      // added index to that fieldName
      match = searchArray.some((item) => item.config.name === field.config.name);
      if (match) {
        field.config.name = `${field.config.name}Field${index}`;
      }

    // If ctrlName = 'form-checkbox' then formArray created
      if (field.ctrlName === 'form-checkbox') {
        if (field.config.hasOwnProperty('options')) {
          let result = field.config.options.map( item => this.fb.control(null));
          if (field.config.hasOwnProperty('required') && field.config.required) {
            acc[field.config.name] = this.fb.array(result, [this.minValidator()]);
          } else {
            acc[field.config.name] = this.fb.array(result);
          }
        }
      } else if (field.ctrlName === 'form-radiobox' || field.ctrlName === 'form-datepicker') {
        if (field.config.hasOwnProperty('required') && field.config.required) {
          acc[field.config.name] = ['', Validators.required];
        } else {
          acc[field.config.name] = [];
        }
      } else {
        acc[field.config.name] = [];
      }
      return acc;
    }, {});

    this.form = this.fb.group(fields);
  }

  /**
   * Submit form handling function
   * @task QLIKTAG-3376
   * @author Lalitkumar Saindane
   */
  submitForm() {
    this.inProgress = true;
    let url;
    const responses = this.getResponses();

    if (this.shortCode) {
      url = `di/data/${this.shortCode}/response`;

      const linkTypeId = this.route.snapshot.queryParamMap.get('linkTypeId');
      //special case for digital link where instance id becomes shortcode 
      if(this.pageService.diinstanceId && linkTypeId ) {

        url = `di/data/template/${linkTypeId}/response?instanceId=${this.pageService.diinstanceId}`;
      }

    }

    if (this.templateId) {
      url = `di/data/template/${this.templateId}/response`;

      if(this.pageService.diinstanceId) {
        url = `di/data/template/${this.templateId}/response?instanceId=${this.pageService.diinstanceId}`;
      }
    }

    if (this.pageService.isDigitalLinkInteraction) {
      url = `di/data/template/${this.templateId}/response?instanceId=${this.pageService.diinstanceId}`;
    }

    //console.log(this.pageService, url)

    //return;

    this.apiService.post(url, {'data': {'responses': responses}})
    .subscribe((result) => {
      this.inProgress = false;
      this.errorMessage = false;
      this.hideForm = true;

       //if redirectUrl has value directly redirect to page from form
       if(this.afterSubmit.mode === 2) {
        if(this.afterSubmit.hasOwnProperty("redirectUrl") && this.afterSubmit.redirectUrl) {
          this.gatemanService.routeHub(this.afterSubmit.redirectUrl)
        } else {
          //if mode is 2 and url not present, then show the form
          this.hideForm = false;
          this.form.reset();
        }
      }

    },
    (error) => {
      this.inProgress = false;
      this.errorMessage = true;
     // console.log("error", error);
    });
  }

  /**
   * [Questions creation function]
   * @task QLIKTAG-3376
   * @author Lalitkumar Saindane
   */
  getResponses() {

    let responses = [];
    let response;

    responses = this.formFields.reduce((acc, control) => {

      let question = {};

      response = this.form.get(control.config.name).value;

      if (control.ctrlName === 'form-checkbox') {
        response = this.getFormatedCheckboxValue(this.form.get(control.config.name).value, control);
      }

      question['fieldName'] = control.config.name;
      question['question'] = control.config.label;

      if (Array.isArray(question['question']) && question['question'].length > 0) {
        if (this.pageService.diLanguages.length > 0) {
          question['question'] = question['question'].filter(item => {
            return this.pageService.diLanguages.includes(item.languageCode);
          });
        }
      } else if(Array.isArray(question['question']) && question['question'].length == 0){
        let defaultLang = this.pageService.appLang$.getValue();
        defaultLang = defaultLang ? defaultLang : 'en';
        question['question'].push({
          languageCode: defaultLang,
          value: ''
        })
      }

      if (Array.isArray(response)) {
        if (response.length > 0) {
          question['response'] = [
            ...response
          ];
        } else {
          question['response'] = [];
        }
      } else {
        response ? question['response'] = [ response ] : question['response'] = [];
      }

      acc.push(question);

      return acc;
    }, []);

    return responses;
  }

  /**
   * [Convert checkbox [true,false] into control options value]
   * @task QLIKTAG-3376
   * @author Lalitkumar Saindane
   */
  getFormatedCheckboxValue(formValue: Array<boolean>, control) {
    let result = [];
    if (formValue.length > 0) {
      formValue.map((item, index) => {
        if (item === true) {
          result.push(control.config.options[index].value);
        }
      });
    }
    return result;
  }

  /**
   * [Filter controls from array where ctrlName startswith form-*]
   * @param controls [Array of controls]
   * @return         [formField]
   * @task QLIKTAG-3376
   * @author Lalitkumar Saindane
   */
  getFormFields(controls: Array<any>) {

    controls.map((item) => {
      if (item.hasOwnProperty('ctrlName') && /^form-/.test(item.ctrlName)) {
        this.formFields.push(item);
      } else {
        if (item.hasOwnProperty('controls') && item.controls.length > 0) {
          this.getFormFields(item.controls);
        }
      }
    });
  }

  /**
   * [get defualt value for radio button]
   * @param config [config of control]
   * @return         [value]
   * @task QLIKTAG-3304
   * @author Lalitkumar Saindane
   */
  // getRadioBoxDefaultValue(config) {
  //   let result;
  //   if (config.hasOwnProperty('options') && config.options.length > 0) {
  //     result = config.options[0].value;
  //   } else {
  //     result = null;
  //   }
  //   return result;
  // }

  /**
   * add css to button after view initialised
   * @author Radhika Agnihotri
   * @task QLIKTAG-3739
   */
  ngAfterViewInit() {
    if (this.submitButtonRef) {
      this.renderer.setStyle(this.submitButtonRef.nativeElement, 'cssText', `--background: ${this.submitButton['backgroundColor']}; --border-color:${this.submitButton["borderColor"]}; --color: ${this.submitButton["color"]}; 
      --background-hover: ${this.submitButton['backgroundColor']}; --background-hover-opacity: 1`);
    }
  }

  /**
   * 
   * @author Radhika Agnihotri
   * @task QLIKTAG-3739
   */
  getWrapperStyle() {
    let properties = {
      "display": 'block'
    };

    if (this.config){

      if(this.submitButton.hasOwnProperty('align')){
        properties['display'] = "flex";
        properties['justify-content'] = this.submitButton.align;
      }

    }
    return properties;
  }

  /**
  * This is custom validator for checkbox formarray. Checks if checkbox is checked atleast one checkbox.
  * @author - Venkatesh Pasala
  * @param minimum - integer. e.g. minimum 1 value should be filled in array.
  * @return - returns angular validator function.
  */
  minValidator(minimum = 1): ValidatorFn {
    return function validate (formGroup: UntypedFormGroup) {
      let checked = 0;
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];
        if (control.value === true) {
          checked ++;
        }
      });
      if (checked < minimum) {
        return { checkboxRequired: true }
      }
      return null;
    };
  }
}
